import { handleActions } from 'redux-actions';
import './actions';
const handler = handleActions({}, {});
export default handler;

//# sourceMappingURL=tierManageContentReducer.js.map